"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_datepicker_1 = __importDefault(require("react-datepicker"));
var Icon_1 = require("../Icon");
require("./DateTimePicker.scss");
var months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
var disabledColor = '#fafafa';
// Add ability to update font size
var CustomDatePickerHeader = function (_a) {
    var date = _a.date, decreaseMonth = _a.decreaseMonth, increaseMonth = _a.increaseMonth, prevMonthButtonDisabled = _a.prevMonthButtonDisabled, nextMonthButtonDisabled = _a.nextMonthButtonDisabled;
    return (React.createElement("div", { className: "sui-flex sui-items-center sui-justify-between sui-mb-2" },
        React.createElement("button", { type: "button", className: "sui-text-gray-9", onClick: decreaseMonth, disabled: prevMonthButtonDisabled },
            React.createElement(Icon_1.Icon, { name: "left" })),
        React.createElement("div", { className: "react-datepicker__current-month sui-text-gray-9" }, "".concat(months[date.getMonth()], " ").concat(date.getFullYear())),
        React.createElement("button", { type: "button", className: "sui-text-gray-9", onClick: increaseMonth, disabled: nextMonthButtonDisabled },
            React.createElement(Icon_1.Icon, { name: "right" }))));
};
var DateTimePicker = function (_a) {
    var id = _a.id, containerClasses = _a.containerClasses, dateFormat = _a.dateFormat, datetime = _a.datetime, disabled = _a.disabled, excludeTimes = _a.excludeTimes, filterTime = _a.filterTime, inputClasses = _a.inputClasses, onChange = _a.onChange, onBlur = _a.onBlur, openToDate = _a.openToDate, placeholderText = _a.placeholderText, showTimeSelect = _a.showTimeSelect, minDate = _a.minDate, filterDate = _a.filterDate;
    return (React.createElement("div", { id: id, style: { backgroundColor: "".concat(disabled ? disabledColor : ''), maxHeight: '48px' }, className: "custom-toolkit-datepicker ".concat(disabled ? 'custom-toolkit-datepicker--disabled' : '', " sui-w-full sui-h-6 sui-flex sui-justify-between sui-items-center sui-border sui-border-solid sui-border-gray-5 sui-rounded sui-py-2 ").concat(containerClasses), "data-testid": "date-time-picker-id" },
        React.createElement(react_datepicker_1.default, { selected: datetime, onChange: onChange, onBlur: onBlur, showTimeSelect: showTimeSelect, timeIntervals: 15, dateFormat: dateFormat || 'Pp', minDate: minDate, placeholderText: placeholderText || 'mm/ dd / yyyy, -- : -- --', className: "sui-w-full sui-h-full sui-border-0 sui-px-0 sui-body ".concat(inputClasses), renderCustomHeader: function (props) { return React.createElement(CustomDatePickerHeader, __assign({}, props)); }, openToDate: openToDate, filterTime: filterTime, excludeTimes: excludeTimes, disabled: disabled, filterDate: filterDate }),
        React.createElement(Icon_1.Icon, { mods: "sui-mr-0.5 ".concat(disabled ? 'sui-text-gray-5' : 'sui-text-gray-9'), name: "calendar-today" })));
};
DateTimePicker.defaultProps = {
    containerClasses: '',
    dateFormat: '',
    disabled: false,
    excludeTimes: [],
    filterTime: function () { return true; },
    onBlur: function () { },
    inputClasses: '',
    openToDate: undefined,
    placeholderText: '',
    showTimeSelect: false,
    minDate: undefined,
    filterDate: function () { return true; },
};
exports.default = DateTimePicker;
